module.exports = __webpack_public_path__ + "img/注意事項icon.c333811e.svg";